type Props = {
  value: number | string;
  currency?: "EUR" | "USD" | "GBP" | string;
  className?: string;
};

export const GenericCoin = ({ value, currency = "EUR", className }: Props) => {
  const display = typeof value === "number" && value < 1 
    ? value.toFixed(2).replace("0.", ".") 
    : value;

  return (
    <svg 
      viewBox="0 0 40 40" 
      className={`w-full h-full max-w-[40px] ${className ?? ""}`}
    >
      {/* Outer rim */}
      <circle cx="20" cy="20" r="19" fill="#d9d9d9" stroke="#999999" strokeWidth="1.5"/>

      {/* Inner metal */}
      <circle cx="20" cy="20" r="16" fill="#f5f5f5"/>

      {/* Subtle shine */}
      <circle cx="20" cy="20" r="12" fill="white" opacity="0.3"/>

      {/* Value — crisp, readable even at 40px */}
      <text
        x="20"
        y="24"
        fontSize={value >= 1 ? "13" : "11"}
        fontWeight="bold"
        textAnchor="middle"
        fill="#333333"
        stroke="#ffffff"
        strokeWidth="2.5"
        paintOrder="stroke fill"
      >
        {display}
      </text>
    </svg>
  );
};

export default GenericCoin;
